import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "@core/auth.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { IonicModule, ModalController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { Subscription, interval } from "rxjs";
import { bounceIn } from "src/app/animations/custom.animation";
import { SyndicateRepositoryService } from "../syndicate-repository.service";

@Component({
  selector: "app-pause-syndicate",
  templateUrl: "./pause-syndicate.component.html",
  styleUrls: ["./pause-syndicate.component.scss"],
  animations: [bounceIn],
  standalone: true,
  imports: [
    IonicModule,
    MatProgressSpinner,
    MatIcon,
    TranslatePipe,
  ],
})
export class PauseSyndicateComponent implements OnInit {
  spinnerAnimation: boolean;
  progressBar: number = 1;
  timer$: any;
  sub: Subscription;
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  proceed = true;
  constructor(
    private bottomSheetRef: MatBottomSheetRef<PauseSyndicateComponent>,
    private syndicateService: SyndicateRepositoryService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private snackService: MySnackBarService,
    private cdRef: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private modalController: ModalController,
    public translate: TranslateService,
    private authService: AuthService,
  ) {
    this.authService.selectedlanguage$.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService.getConstantsMsg$.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    })
  }

  ngOnInit() { }

  closePauseSyndicateDialog(result: boolean) {
    this.bottomSheetRef.dismiss(result);
  }

  startSpinner() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    this.timer$ = interval(20);
    this.sub = this.timer$?.subscribe(
      (sec) => {
        this.progressBar = 0 + sec;
        this.cdRef.detectChanges();
      },
      (err) => {
        return (err);
      }
    );
    this.cdRef.detectChanges();
  }

  pauseSyndicate() {
    if (this.data?.syndicate?.next_draw_status === "unpaid" || !window?.navigator?.onLine) {
      this.authService.getConstantsMsg("1057").then((translatedMsg) => {
        const defaultMsg = {
          message: {
            line_1: "Can't pause syndicate which you are not playing",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      }).catch((error) => {
        return error;
      });
      this.bottomSheetRef.dismiss(false);
      return;
    }
    this.syndicateService
      .pauseSyndicate(
        this.data?.syndicate?.id
          ? this.data?.syndicate?.id
          : this.data?.syndicate?.encrypted_id
            ? this.data?.syndicate?.encrypted_id
            : this.data?.syndicate?.sId,
        this.data?.syndicate?.cardType,
        this.data?.syndicate?.syndicate_pause_gift,
      )
      .subscribe((res) => {
        this.progressBar === 100;
        this.sub?.unsubscribe();
        this.cdRef.detach();
        if (res?.status === "rejected") {
          this.authService.getConstantsMsg(res?.error_code).then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Something went wrong!",
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          }).catch((err) => {
            return err
          });
          this.bottomSheetRef.dismiss(false);
          return;
        }
        if (res?.response?.status?.toLowerCase() === "success") {
          setTimeout(() => {
            //this.showToast("Syndicate has been <b>paused</b>", "paused");
            this.authService.getConstantsMsg("1063").then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Syndicate has been <b>paused</b>",
                  line_2: "",
                },
                style: {
                  icon: "tick circle success.png",
                  type: "Success",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);

            }).catch((error) => {
              return error;
            });
          }, 2000);
          this.bottomSheetRef.dismiss(true);
        } else {
          setTimeout(() => {
            // this.showToast(res?.response?.message ?? SYNDICATE_PAUSE_FAILURE, "Error");
            const translatedMsg = {
              message: {
                line_1: res?.response?.message,
                line_2: "",
              },
              style: {
                duration: 2000,
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            const defaultMsg = {
              message: {
                line_1: "Something went wrong!",
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          }, 2000);
          this.bottomSheetRef.dismiss(false);
        }

        setTimeout(async () => {
          this.spinnerAnimation = false;
          this.proceed = false;
          await new Promise<void>((resolve) => {
            setTimeout(() => {
              this.proceed = true;
              resolve();
            }, 2000);
          });
        }, 300);
      });
  }
  getResumeDate() {
    return moment()?.add(28, "days").format("DD MMM YYYY");
  }
}
